import { render } from "./RemoveToolUserAssignment.vue?vue&type=template&id=56bbad28&scoped=true&ts=true&lang=pug"
import script from "./RemoveToolUserAssignment.vue?vue&type=script&lang=ts"
export * from "./RemoveToolUserAssignment.vue?vue&type=script&lang=ts"

import "./RemoveToolUserAssignment.vue?vue&type=style&index=0&id=56bbad28&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bbad28"]])

export default __exports__